import { useSelector } from 'react-redux';
import useGrowthBookFeatureValue from 'components/GrowthBookProvider/useGrowthBookFeatureValue';
import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';
import {
  purchaseMatchesShowPricesByGroupAllowedRoutes,
  resolveShowPricesByGroupConfig,
} from 'utils/showPricesByGroup';

/**
 * Encapsulates the "show prices by group" behaviour for the seat selection flow only.
 * Requires: USE_SEAT_BASED_PRICING (whitelabel) + show_prices_by_group (GrowthBook), and showPricesByGroupConfig:
 * - Config missing: never shown.
 * - enabledOnAllRoutes === true: shown on all routes.
 * - enabledOnAllRoutes === false: shown only if the route is in showPricesByGroupConfig.allowedRoutes.
 *
 * Pure route logic lives in {@link utils/showPricesByGroup}.
 *
 * @returns {boolean} True when flags and route config allow showing the feature.
 */
const useShowPricesByGroup = () => {
  const { features } = useSelector((state) => state.whitelabelConfig);
  const { showPricesByGroupConfig } = useWhitelabelEnvs();
  const purchase = useSelector((state) => state.purchase?.toJS?.() || {});
  const search = useSelector((state) => state.search);
  const showPricesByGroupGB = useGrowthBookFeatureValue('show_prices_by_group');

  const flagsOn = Boolean(features.USE_SEAT_BASED_PRICING) && Boolean(showPricesByGroupGB);
  if (!flagsOn) return false;

  const resolved = resolveShowPricesByGroupConfig(showPricesByGroupConfig);
  if (resolved === false) return false;
  if (resolved === true) return true;

  return purchaseMatchesShowPricesByGroupAllowedRoutes(purchase, search, resolved);
};

export default useShowPricesByGroup;
